import { InvestmentFundService } from './../investment-fund.services';
import { Component, EventEmitter, Input, OnInit, Output, QueryList, Renderer2, ViewChild, ViewChildren } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NgbModal, NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { catchError } from 'rxjs';
import { AgGridDataModelCreateScheme} from './create-scheme.model'
import { AgGridComponent } from '../../../../shared/common-components/ag-grid/ag-grid.component';
import { AgGridI, Pagination, PaginationModel } from '../../../../shared/common-components/ag-grid/ag-grid.model';
import { AgGridService } from '../../../../shared/common-components/ag-grid/ag-grid.service';
import { PaginationPageSizes } from '../../../../shared/components/common-model/common-model';
import { StorageName } from '../../../../shared/enum/common-enum';
import { CommonService } from '../../../../shared/services/common.service';
import { SendDataService } from '../../../../shared/services/send-data.service';
import { StorageService } from '../../../../shared/services/storage.service';
import { GridOptions } from 'ag-grid-community';
import {InsertUpdateSchemeModel}from '../investment-fund.model'
import { ResponseModel } from '../../../../shared/models/response-model.model';
import { InvestmentFundComponent } from '../investment-fund.component';
import { ReportService } from '../../../../components/report/report.service';
import { ExcelConverterServiceService } from '../../../../shared/services/excel-converter-service.service';
import { FileReaderService } from '../../../../shared/services/file.reader.service';
import { NotificationService } from '../../../../shared/services/notification.service';
import { CommonFilterService } from '../../../../shared/services/common-filter.service';
import { IconHover } from '../../../../shared/enum/common-enum';
@Component({
  selector: 'app-create-scheme',
  templateUrl: './create-scheme.component.html',
  styleUrls: ['./create-scheme.component.scss']
})
export class CreateSchemeComponent extends CommonService implements OnInit  {
 insertUpdateSchemeModel = new InsertUpdateSchemeModel();
 @ViewChild(InvestmentFundComponent)investmentFundComponent : InvestmentFundComponent;
 @ViewChild("createSchemeForm") createSchemeForm!: NgForm;
 @Input() data;
 @Output() sendDataToParent: EventEmitter<string> = new EventEmitter();
 @Output() send = new EventEmitter();
  formName = StorageName.FORMNAME_TRANSACTION_INVESTMENT_LAYAWAYS_FUND;
  // activeTabId: any;
  formModel :  any = {};
  sumOfinstallmentAmount: string = '0';
  agGridDataModelCreateScheme:AgGridI;
  getAllgetAllcreateschemerowData: any[] = [];
  pageSize = 10;
  currentPage = 1;
  totalRecords: number;
  paginationPageSizes            = new PaginationPageSizes();   
  getAllDropdownModel            : any = {};  
  storageName                    = StorageName;
  pagination                     = new PaginationModel();
  basicPagination = new Pagination();
  apiRequestModel : any = {};
  gridApiCreateSchemeList : any;
  apiRequestStorageName = StorageName.APIREQUEST_INVESTMENT_FUND_CREATE_SHECEM_GRID;
  paginationStorageName = StorageName.PAGINATION_INVESTMENT_FUND_CREATE_SHECEM_GRID;
  @ViewChildren(AgGridComponent) grids: QueryList<AgGridComponent>
  fromDate: any;
  toDate: any;
  isLoading: boolean = false;
  submit: boolean =false;
  getAllDropdown:any = {};
  gridApi:any
  currentHoverEffect = IconHover.Pink;

  constructor(
    public storageService:StorageService ,
    public renderer : Renderer2,
    public agGridService : AgGridService , 
    private sendDataService :SendDataService,
    private modalService: NgbModal,
    public toaster: ToastrService,
    public commonFilterService:CommonFilterService,
    public fileReaderService : FileReaderService,
    public excelConverterServiceService:ExcelConverterServiceService,
    private reportService : ReportService,
    public notificationService: NotificationService,   
    public investmentFundService   : InvestmentFundService,
    private offcanvas: NgbOffcanvas
    )
    {
      super(renderer);
     }
  row=[{taskEventTitle:'1',},{taskEventTitle:'1',},{taskEventTitle:'1',},{taskEventTitle:'1',},{taskEventTitle:'1',},{taskEventTitle:'1',}];
  gridOptionsCreateScheme: GridOptions = {
    suppressClickEdit:true,
    getRowStyle: this.getRowStyle,
  };
  getRowStyle(params: any) {
    return {
      background: params?.node?.rowIndex % 2 === 0 ? '#EEF1F7' : '#FFFFFF',
    };
  }
  ngOnInit(): void {
    this.agGridDataModelCreateScheme = AgGridDataModelCreateScheme;
    this.agGridDataModelCreateScheme.isServerSidepagination =true;
    this.agGridDataModelCreateScheme.showPagination =true;
    if (this.data?.schemeId != 0 ) {
      this.getSchemeDetailById();
    }
    this.fillDropdownData();
  };

  onDeleteIconClick(params){
    this.onDeleteRowClickedResponse(params?.detail?.data?.data?.id);
  }

  onDeleteRowClickedResponse(id: any) 
  {
    this.investmentFundService.deleteSchemeDetail(id).subscribe(res =>{
      if(res?.isSuccess){
        this.toaster.success(res?.message);
        this.formModel ={};
      }
    })
  }

  handleTextClick(event) {
    const data = event?.data;
    this.cellClicked(data);
  }

  cellClicked(data){
    this.formModel = data;
    const sendData ='Update';
    this.sendDataToParent.emit(sendData);
  }
    

refreshGridApi(){
  this.gridApiCreateSchemeList?.api?.refreshHeader();
}

fillDropdownData(){
  this.getAllDropdownModel.durationTypeDropdown = this.storageService.retrieve(StorageName.DURATION_TYPE_DROPDOWN);
  this.getAllDropdownModel.statusCodeDropdown = this.storageService.retrieve(StorageName.STATUS_DROPDOWN);
  this.getAllDropdownModel.installmentTypeDropdown = this.storageService.retrieve(StorageName.INSTALLMENT_TYPE_DROPDOWN);
  this.getAllDropdownModel.redemptionOnDropdown = this.storageService.retrieve(StorageName.REDEMPTION_ON_DROPDOWN);
}

onGridReady(event: any) {
 this.gridApi = event;
  this.gridApiCreateSchemeList = event;
  this.getAllCreateSchemeList()
}

callApiForExport(){
  const exportAs = this.apiRequestModel?.exportAs;
  this.investmentFundService.getAllSchemeDetails(this.apiRequestModel).subscribe(
    {
      next: (res) => {
      this.fileReaderService.exportFile(res, exportAs);
      },error(error) {
      console.error('Error in downloading Excel/Pdf file:', error);
      },
     }
  );
}

onPagination(pagination: PaginationModel) {
  this.storeChangedPagination(pagination);
  this.getAllCreateSchemeList();
}

storeChangedPagination(paginationModel: PaginationModel) {
  this.pagination = this.commonFilterService.storeChangedPagination(paginationModel, this.pagination,this.paginationStorageName,this.apiRequestStorageName);
}

addFooterAndCalculation(params: any, data: any[]): void {
  this.sumOfinstallmentAmount = data[0]?.installmentAmount;
  const totalsObject = {
    installmentAmount: this.sumOfinstallmentAmount,
    isFooterRow: true
  };
  params?.api.setPinnedBottomRowData([totalsObject]);
  params?.api?.refreshCells();
}

getAllCreateSchemeList() {
  this.isLoading = true;
  this.showLoading(this.gridApiCreateSchemeList);
  const filter = {
    rules: [{}],
    groups: [{}]
  };
  this.apiRequestModel = this.storageService.retrieve(this.apiRequestStorageName) || {};
  this.apiRequestModel.filter = JSON?.stringify(filter);
  this.investmentFundService.getAllSchemeDetails(this.apiRequestModel).subscribe({
    next: (res) => {
      const allRecordsSumRow = res?.response?.data?.filter(a => a?.isSumRow);
      this.commonFilterService.processServersideApiResponse(res, this.grids?.first, this.gridApiCreateSchemeList, this.pagination, this.pagination?.getAll);
      this.addFooterAndCalculation(this.gridApiCreateSchemeList, allRecordsSumRow);
    },
    error: () => {
      this.hideLoading(this.gridApiCreateSchemeList);
      this.handleErrorResponse();
    }
  });
}

handleErrorResponse(res = null) {
  this.getAllgetAllcreateschemerowData = [];
  this.gridApiCreateSchemeList?.api?.setRowData([]);
  this.addFooterAndCalculation(this.gridApiCreateSchemeList, [0]);
  if (res) {
    this.notificationService.errorPopup(res?.errors[0]);
  }
}

close(){
  this.offcanvas.dismiss();
}

  insertUpdateSchemeDetails() {
    this.submit = true;
  
    // Check for required fields
    const requiredFields = [
      'schemeName', 
      'duration', 
      'durationTypeId', 
      'installmentTypeId', 
      'redemptionOnId', 
    ];
  
    let isValid = true;
  
    requiredFields.forEach(field => {
      if (!this.insertUpdateSchemeModel[field]) {
        isValid = false;
      }
    });
  
    if (!isValid) {
      return;
    }
  
    // Reset submit flag if all validations pass
    this.submit = false;
  
    const createSchemeObservable = this.insertUpdateSchemeModel?.id 
      ? this.investmentFundService.updateSchemeDetails(this.insertUpdateSchemeModel) 
      : this.investmentFundService.insertSchemeDetails(this.insertUpdateSchemeModel);
  
    createSchemeObservable.pipe(
      catchError(async (err) => this.toaster.error(err?.error?.errors[0]))
    ).subscribe((res: ResponseModel) => {
      if (res?.isSuccess) {
        this.offcanvas.dismiss(res?.isSuccess)
        this.toaster.error(res?.errors[0]);
      } else {
        this.toaster.error(res?.errors[0]);
      }
    });
  }
  
  public clearAsyncValidators( form : NgForm){
    Object.keys(form?.controls).forEach(field => {
      const control = form?.controls[field];
      control?.markAsUntouched({ onlySelf: true});
    })
  }

  saveInsertUpdateShemeData()
  {
    if(!((this.formModel?.id ) ? this.sendDataService?.permissionVM?.investmentFundCanUpdate : this.sendDataService?.permissionVM?.investmentFundCanAdd)) return
    if(this.createSchemeForm?.valid){ 
      this.insertUpdateSchemeModel =this.formModel; 
      if(this.insertUpdateSchemeModel?.installmentAmount === '') this.insertUpdateSchemeModel.installmentAmount = '0';
       const createSchemeObservable = this.insertUpdateSchemeModel?.id 
       ? this.investmentFundService.updateSchemeDetails(this.insertUpdateSchemeModel) 
       : this.investmentFundService.insertSchemeDetails(this.insertUpdateSchemeModel);
       createSchemeObservable.subscribe({
        next:(res)=>{
          if(res?.isSuccess)
          {
            this.toaster.success(res?.message);
            this.getAllCreateSchemeList();
            this.submit =false;
            this.newCreateScheme();
            this.formModel.installmentAmount = '0';
            this.offcanvas.dismiss(res?.isSuccess);
          }
        }
      });
    }else{
      this.submit =true;
      this.toaster.error("Fill Required Fields");
    }
  }
 
  clearData() {
    this.gridApiCreateSchemeList?.api?.deselectAll();
  }

ngOnDestroy() {
  this.agGridDataModelCreateScheme.rows =[];
  this.gridApiCreateSchemeList?.api?.setRowData([]);
  this.storageService.removeItem(this.apiRequestStorageName); 
}

newCreateScheme()
{
  this.insertUpdateSchemeModel = new InsertUpdateSchemeModel();
  this.formModel ={};
  this.createSchemeForm.reset(); 
  this.formModel.installmentAmount = '0';
  if (this.createSchemeForm) {
    this.clearAsyncValidators(this.createSchemeForm);
  }
  const sendData ='Save'
  this.sendDataToParent.emit(sendData);
}

getSchemeDetailById(){
   this.investmentFundService.getSchemeDetailId(this.data?.schemeId).subscribe({
    next:(res)=>{
      if(res?.isSuccess){
        if(res?.response){
          this.formModel = res?.response;
        } else{
          this.insertUpdateSchemeModel = new InsertUpdateSchemeModel();
          this.formModel ={};
        }
      }else{
        this.insertUpdateSchemeModel = new InsertUpdateSchemeModel();
        this.formModel ={};
      }
    },error:(err)=>{
      this.insertUpdateSchemeModel = new InsertUpdateSchemeModel();
      this.formModel ={};
    }
  })
}

  onSortIconClick(event) {
   this.commonFilterService.storeChangedSortList(this.agGridDataModelCreateScheme?.sortStorageName, this.apiRequestStorageName);
    this.getAllCreateSchemeList();
  }

}
